/**
 * Token storage utility for managing authentication tokens
 *
 * Security approach:
 * - Access token stored in memory (not localStorage) to prevent XSS attacks
 * - Refresh token stored as httpOnly cookie by backend (not accessible via JS)
 * - Remember me preference stored in localStorage
 */

const REMEMBER_ME_KEY = 'auth_remember_me'

// In-memory storage for access token (more secure than localStorage)
let accessToken: string | null = null

export const tokenStorage = {
  /**
   * Get the access token from memory
   */
  getToken(): string | null {
    return accessToken
  },

  /**
   * Set the access token in memory
   */
  setToken(token: string): void {
    accessToken = token
  },

  /**
   * Remove the access token from memory
   */
  removeToken(): void {
    accessToken = null
  },

  /**
   * Get remember me preference
   */
  getRememberMe(): boolean {
    return localStorage.getItem(REMEMBER_ME_KEY) === 'true'
  },

  /**
   * Set remember me preference
   */
  setRememberMe(remember: boolean): void {
    if (remember) {
      localStorage.setItem(REMEMBER_ME_KEY, 'true')
    } else {
      localStorage.removeItem(REMEMBER_ME_KEY)
    }
  },

  /**
   * Clear all tokens and preferences
   */
  clear(): void {
    this.removeToken()
    localStorage.removeItem(REMEMBER_ME_KEY)
  },
}
